// eslint-disable-next-line no-unused-vars
import React, { useState } from "react";
import { Modal, Button } from "antd";
import {
  ExclamationCircleOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
const SubscriptionDeleteModal = ({
  recordData,
  isVisible,
  onCancel,
  onConfirm,
}) => {
  //console.log(isVisible);

  return (
    <Modal
      open={isVisible}
      centered
      width={400}
      title={
        <div>
          <ExclamationCircleOutlined
            style={{ color: "#ff4d4f", marginRight: 8, fontSize: "2rem" }}
          />
          Delete Subscription
        </div>
      }
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="confirm"
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
          }}
          className="save-update-btn"
          onClick={() => onConfirm(recordData)}
        >
          <UserDeleteOutlined /> Delete
        </Button>,
      ]}
    >
      <p className="myapps">
        Are you sure you want to delete the subscription{" "}
        <strong>{recordData?.application}</strong>?
      </p>
      <p className="myapps">
        This subscription contains{" "}
        <strong>{recordData?.can_be_deleted?.user_count}</strong> user(s).
      </p>
    </Modal>
  );
};

export default SubscriptionDeleteModal;
